import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const pageHasSummaryElement = (formConfig: FormConfig | undefined, pageId: string) => {
    if (!formConfig) return;

    const currentPage = formConfig.pages.find((page) => page.pageId === pageId);

    if (currentPage) {
        const isSummaryPage = !!currentPage.elements.find((element) => element.type === 'summaryPage');
        return isSummaryPage;
    } else {
        return false;
    }
};
